import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { css, Global } from '@emotion/core'

import { IntlProvider } from '@divvy-web/i18n'
import { ToastProvider } from '@divvy-web/skylab.toast'

import client from './apollo/ApolloClient'
import { AuthProvider } from './auth'
import FullPageFallback from './components/FullPageFallback'
import PageErrorBoundary from './components/PageErrorBoundary'
import Root from './components/Root'
import ThemeProvider from './components/theme-provider'
import { ExperimentTrackingProvider } from './experiments'
import { WebTrackingProvider } from './tracking/WebTrackingContext'

const GlobalToastStyle = () => <Global styles={globalToastStyle} />

const globalToastStyle = ({ mq }) => css`
  // The value of z-index for the toast is required to be this high
  // because it needs to supersede the z-index value of intercom launcher button
  // which is > 2100000000

  .Toast {
    ${mq.xxSmallMaxWidth({ zIndex: '2500000000 !important' })}
  }

  .Toast-container {
    ${mq.xxSmallMaxWidth({
      padding: 'var(--tri-space-150) var(--tri-space-300) !important',
      width: '90% !important',
    })}
  }

  .Toast-msg {
    ${mq.xxSmallMaxWidth({ fontSize: '4vw', overflowWrap: 'anywhere' })}
  }
`

const AppProvider = () => {
  return (
    <IntlProvider
      locale='en'
      textComponent='span'
    >
      <ThemeProvider>
        <ToastProvider>
          <ApolloProvider client={client}>
            <AuthProvider>
              <WebTrackingProvider>
                <ExperimentTrackingProvider>
                  <GlobalToastStyle />
                  <Root>
                    <PageErrorBoundary>
                      <Suspense fallback={<FullPageFallback />}>
                        <Outlet />
                      </Suspense>
                    </PageErrorBoundary>
                  </Root>
                </ExperimentTrackingProvider>
              </WebTrackingProvider>
            </AuthProvider>
          </ApolloProvider>
        </ToastProvider>
      </ThemeProvider>
    </IntlProvider>
  )
}

export default AppProvider
